import React from 'react'
import Layout from '../../components/help/Layout/Layout'
import Seo from '../../components/help/Seo'
import Header from '../../components/ui/Header/Header'
import Intro from '../../components/ui/Intro/Intro'

import Contacts from '../../components/pages/Contacts/Contacts'
import { getHrefToHome } from '../../utils/getHrefToHome'
import { useStaticQuery, graphql } from 'gatsby'

const ContactsPage = () => {
    const lang = 'en'

    const hrefHome = getHrefToHome(lang)

    const data = useStaticQuery(graphql`
        {
            title: datoCmsRenshinPageContact(title: { eq: "Title" }, locale: { eq: "en" }) {
                value
            }

            titleForm: datoCmsRenshinPageContact(title: { eq: "Title form" }, locale: { eq: "en" }) {
                value
            }

            blockTitleOne: datoCmsRenshinPageContact(title: { eq: "Block 1: Title" }, locale: { eq: "en" }) {
                value
            }

            blockTextOne: datoCmsRenshinPageContact(title: { eq: "Block 1: Text" }, locale: { eq: "en" }) {
                value
            }

            blockTitleTwo: datoCmsRenshinPageContact(title: { eq: "Block 2: Title" }, locale: { eq: "en" }) {
                value
            }

            blockTextTwo: datoCmsRenshinPageContact(title: { eq: "Block 2: Text" }, locale: { eq: "en" }) {
                value
            }

            thanksTitle: datoCmsRenshinPageContact(title: { eq: "Thanks: Title" }, locale: { eq: "en" }) {
                value
            }

            thanksText: datoCmsRenshinPageContact(title: { eq: "Thanks: Text" }, locale: { eq: "en" }) {
                value
            }

            social: allDatoCmsRenshinSocial(filter: { locale: { eq: "en" } }) {
                nodes {
                    title
                    url
                }
            }

            seo: datoCmsRenshinSeo(originalId: { eq: "114097373" }, locale: { eq: "en" }) {
                titleH1
                crumbsName
                bgDesktop {
                    url
                }
                bgTabletA {
                    url
                }
                bgTabletP {
                    url
                }

                bgMobile {
                    url
                }
                footerLinks {
                    title
                    url
                }
                seo {
                    title
                    description
                }
            }

            main: datoCmsRenshinSeo(originalId: { eq: "114097337" }, locale: { eq: "en" }) {
                crumbsName
            }
        }
    `)

    const breadCrumbs = [
        { name: `${data.main.crumbsName}`, href: `${hrefHome}`, current: false },
        { name: `${data.seo.crumbsName}`, current: true }
    ]

    const photo = {
        1920: data.seo.bgDesktop?.url,
        1440: data.seo.bgDesktop?.url,
        1024: data.seo.bgTabletA?.url,
        768: data.seo.bgTabletP?.url,
        360: data.seo.bgMobile?.url
    }

    return (
        <Layout lang={lang}>
            <Seo title={data.seo?.seo?.title} description={data.seo?.seo?.description} />

            <Header light lang={lang} />
            <Intro crumbs={breadCrumbs} title={data.seo.titleH1} photo={photo} lang={lang} />
            <Contacts data={data} lang={lang} />
        </Layout>
    )
}

export default ContactsPage
